import React from "react";
import { Link } from "react-router-dom";

const PageHero = ({ title, subtitle, image, breadcrumb }) => {
  return (
    <section className="relative h-[60vh] bg-[#FBF8F1] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${image}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/50 to-black/50" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#FBF8F1]/34 via-[#F7F2E8]/34 to-[#FBF8F1]/34" />
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "radial-gradient(circle at center, rgba(200,168,120,0.20), transparent 60%)",
        }}
      />
      <div className="relative h-full max-w-7xl mx-auto px-6 flex flex-col items-start justify-center text-left">
        {subtitle && (
          <p className="font-script text-4xl md:text-5xl text-[#F4B63A] p-2 drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]">
            {subtitle}
          </p>
        )}
        <h1 className="font-cinzel  text-2xl md:text-4xl lg:text-5xl text-[#E9AA2E] tracking-[0.15em] uppercase mt-2 max-w-4xl leading-tight drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]">
          {title}
        </h1>
        <div className="flex items-center justify-start gap-3 mt-6">
          <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#B79A68]" />
          <Link
            to="/"
            className="text-[#F3BF4A] hover:text-[#FFD76A] text-[11px] uppercase tracking-[0.3em] font-cinzel"
          >
            Home
          </Link>
          {breadcrumb && (
            <>
              <span className="text-[#F3BF4A]">/</span>
              <span className="text-[#E9AA2E] text-[11px] uppercase tracking-[0.3em] font-cinzel">
                {breadcrumb}
              </span>
            </>
          )}
          <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#B79A68]" />
        </div>
      </div>
      <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#B79A68] to-transparent" />
    </section>
  );
};

export default PageHero;
